/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { TagType } from '../enums/tag-type';
export class TagEntity extends Entity {
  id: string = '';
  name: string | null = null;
  parentId: string | null = null;
  type: TagType | null = null;
  static override key = 'Tag';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Tag' in input
    ) {
      const { Tag: wrapped, ...rest } = input as {
        Tag: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}